import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 14l-4 -4l4 -4","key":"svg-0"}],["path",{"d":"M5 10h11a4 4 0 1 1 0 8h-1","key":"svg-1"}]]

/**
 * IconArrowBackUp
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctYmFjay11cCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNOSAxNGwtNCAtNGw0IC00IiAvPgogIDxwYXRoIGQ9Ik01IDEwaDExYTQgNCAwIDEgMSAwIDhoLTEiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/arrow-back-up
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowBackUp = createReactComponent('outline', 'arrow-back-up', 'ArrowBackUp', __iconNode);

export default IconArrowBackUp;